<template>
    <div>
        <div class="sticky-bar bg-white" ref="stickyBar">
            <hr class="my-0">
            <div class="container">
                <div class="row">
                    <div class="col-12 my-4 d-flex align-items-center ">
                        <div class="viewing-buttons d-none d-md-block">
                            <p class="d-inline mr-3">Viewing:</p>
                            <button @click="scrollToJourneyDetails()" :class="getViewingButtonClass('details')" :type="'details'" class="btn mr-2 ">
                                Journey details
                            </button>
                            <button @click="scrollToElementMap()"  :class="getViewingButtonClass('map')" :type="'map'" class="btn mr-2">
                                Map of journey
                            </button>
                            <button @click="scrollToElementSteps()"  :class="getViewingButtonClass('steps-journey')" :type="'step-by-step'" class="btn mr-2">
                                Step by step guide
                            </button>
                        </div>
                        <button @click="print" class="btn btn-outline-secondary ml-auto mr-auto mr-md-0 px-4 py-2">
                            <svg-icon aria-labelledby="print button icon" :name="this.brand + '/print'"></svg-icon>
                                Print
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            brand: whitelabel.brand,
            selected: '',
        }
    },
    methods: {
        scrollToElementMap() {
            this.selected = 'map'
            const el = document.getElementById('map')

            if (el) {
                el.scrollIntoView({ behavior: 'smooth' })
            }
        },
        scrollToElementSteps() {
            this.selected = 'step-by-step'
            const el = document.getElementById('steps-journey')

            if (el) {
                el.scrollIntoView({ behavior: 'smooth' })
            }
        },
        scrollToJourneyDetails() {
            this.selected = 'details'
            const el = document.getElementById('details')
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' })
            }
        },
        handleScroll() {
            if (this.$parent.$refs.map !== undefined && this.$parent.$refs.map.offsetTop) {
                const posWithStickyBarOffset = window.scrollY + this.$parent.$refs.stickyBar.offsetHeight + this.$refs.stickyBar.getBoundingClientRect().top

                if (posWithStickyBarOffset < this.$parent.$refs.map.offsetTop) {
                    this.selected = 'details'
                    this.getViewingButtonClass();
                } else if (posWithStickyBarOffset > this.$parent.$refs.map.offsetTop && posWithStickyBarOffset < this.$parent.$refs.stepByStep.offsetTop) {
                    this.selected = 'map'
                    this.getViewingButtonClass();
                } else if (posWithStickyBarOffset > this.$parent.$refs.stepByStep.offsetTop) {
                    this.selected = 'steps-journey'
                    this.getViewingButtonClass();
                }
            }
        },
        getViewingButtonClass(type) {
            if (this.selected === type) {
                return 'btn-outline-primary'
            }
            return 'btn-outline-secondary'
        },
        print() {
            window.print()
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },


}

</script>
